import { expectCurrentScene } from "../../util";
import { playSceneVideo } from "../playSceneVideo";

export function replayVideo() {
    const scene = expectCurrentScene();
    playSceneVideo(scene);
}
